import dayjs from "dayjs"
import { localisedValue } from "utils"

export const getAddTaskInitialValues = (lead, isEditing) => {
  const isValidUnixTimestamp = timestamp => Number.isInteger(timestamp) && timestamp > 0

  if (isEditing) {
    const statusDetails = lead?.inquiryStatusDetails || {}
    const tasks = lead?.tasks?.[0] || {}
    const calendarEvent = tasks?.CalendarEvent || {}

    let preFilledObject = {
      task: null,
      subTask: null,
      subofSubTask: null,
      subLocation: null,
      nextTask: null,
    }

    if (statusDetails) {
      const {
        taskStatusGreatGrandParentKey,
        taskStatusGrandParentKey,
        taskStatusParentKey,
        taskStatusKey,
        nextStatusKey,
      } = statusDetails

      if (!!taskStatusGreatGrandParentKey) {
        preFilledObject = {
          task: taskStatusGreatGrandParentKey,
          subTask: taskStatusGrandParentKey,
          subofSubTask: taskStatusParentKey,
          subLocation: taskStatusKey,
          nextTask: nextStatusKey,
        }
      } else if (!!taskStatusGrandParentKey) {
        preFilledObject = {
          task: taskStatusGrandParentKey,
          subTask: taskStatusParentKey,
          subofSubTask: taskStatusKey,
          nextTask: nextStatusKey,
        }
      } else {
        preFilledObject = {
          task: taskStatusParentKey,
          subTask: taskStatusKey,
          nextTask: nextStatusKey,
        }
      }
    }
    return {
      task: preFilledObject.task,
      completionDate: tasks?.deadline ? dayjs(tasks.deadline) : dayjs(),
      subTask: preFilledObject.subTask,
      dateSlot: isValidUnixTimestamp(calendarEvent?.startTimeStamp) ? dayjs.unix(calendarEvent.startTimeStamp) : null,
      timeSlot: isValidUnixTimestamp(calendarEvent?.startTimeStamp)
        ? [dayjs.unix(calendarEvent.startTimeStamp), dayjs.unix(calendarEvent.endTimeStamp)]
        : null,
      subofSubTask: preFilledObject.subofSubTask,
      subLocation: preFilledObject.subLocation,
      attachment: tasks?.Attachments || [],
      comment: localisedValue({ object: tasks, key: "description" }) || null,
      nextTask: preFilledObject.nextTask,
      deadLine: tasks?.Todo?.nextStatusDeadline ? dayjs(tasks.Todo.nextStatusDeadline) : dayjs(),
      project: localisedValue({ object: lead?.Project, key: "projectId" }),
      tsrClassification: lead?.inquiry?.InternalInquiryClassification?.id?.toString() || "",
      salesEvent: lead?.tasks?.find(item => item.hasOwnProperty("todoDetails"))?.salesEventId,
    }
  }

  // For non-editing case
  return {
    deadLine: dayjs().add(3, "days"),
    attachment: [],
    project: localisedValue({ object: lead?.Project, key: "projectId" }),
    tsrClassification: lead?.inquiry?.InternalInquiryClassification?.id?.toString() || "",
  }
}
